import { StyleSheet } from 'react-native';
import { Buttons } from 'src/theme-v2/buttons';

export const styles = StyleSheet.create({
  button: {
    backgroundColor: Buttons.quaternaryOnDark.ButtonQuaternaryOnDarkBgDefault,
  },
  buttonHover: {
    backgroundColor: Buttons.quaternaryOnDark.ButtonQuaternaryOnDarkBgHover,
  },
  buttonPressed: {
    backgroundColor: Buttons.quaternaryOnDark.ButtonQuaternaryOnDarkBgPressed,
  },
  buttonFocus: {
    backgroundColor: Buttons.quaternaryOnDark.ButtonQuaternaryOnDarkBgDefault,
  },
  buttonDisabled: {
    cursor: 'not-allowed',
    backgroundColor: Buttons.quaternaryOnDark.ButtonQuaternaryOnDarkBgDisable,
  },

  icon: {
    color: Buttons.quaternaryOnDark.ButtonQuaternaryOnDarkIconDefault,
  },
  iconHover: {
    color: Buttons.quaternaryOnDark.ButtonQuaternaryOnDarkIconDefault,
  },
  iconPressed: {
    color: Buttons.quaternaryOnDark.ButtonQuaternaryOnDarkIconDefault,
  },
  iconDisabled: {
    color: Buttons.quaternaryOnDark.ButtonQuaternaryOnDarkIconDisable,
  },
  iconFocus: {
    color: Buttons.quaternaryOnDark.ButtonQuaternaryOnDarkIconDefault,
  },
});
